<mat-icon class="{{iconColorClass}} ml-1 cursor-pointer"
          *ngIf="infoText"
          (click)="openInfoDialog()"
          [style.font-size.px]="sizeInPx"
          [style.width.px]="sizeInPx"
          [style.height.px]="sizeInPx">
  info
</mat-icon>
